function initSalesNotes(root = document) {
  root.querySelectorAll('[data-sales-note-random]').forEach((el) => {
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    if (Number.isNaN(min) || Number.isNaN(max)) return;

    const low = Math.min(min, max);
    const high = Math.max(min, max);
    el.textContent = Math.floor(Math.random() * (high - low + 1)) + low;
  });
}

initSalesNotes();
document.addEventListener('shopify:section:load', (event) => initSalesNotes(event.target));
